/**
 *
 * UserClients
 *
 */

import React, { useState, useEffect } from 'react';
import { getMandators } from 'lib/api/mandators';
import { Flex } from '@domonda/ui';
import { List, ListItem, ListItemText, Divider, makeStyles } from '@material-ui/core';
import { useIntl } from 'react-intl';
import { CircularLoading } from 'modules/Loading/CircularLoading';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
    marginTop: '20px',
  },
  title: {
    fontFamily: 'sans-serif',
    fontSize: '20px',
  },
}));

export interface MandatorsProps {}

export const UserClients: React.FC<MandatorsProps> = () => {
  const [data, setData] = useState({ Clients: null });
  const { formatMessage } = useIntl();
  useEffect(() => {
    async function populate() {
      const res = await getMandators();
      setData(res);
    }
    populate();
  }, []);

  const classes = useStyles();
  if (data.Clients === null)
    return (
      <Flex item>
        <CircularLoading />
      </Flex>
    );
  if (data.Clients && ((data.Clients as unknown) as any[])!!.length === 0)
    return (
      <div>
        <h3 className={classes.title}>{formatMessage({ id: 'SETTINGS_Clients' })}</h3>
        <Divider />
        <h3 className={classes.title}>{formatMessage({ id: 'SETTINGS_ALL_Clients' })}</h3>
      </div>
    );
  return (
    <div>
      <h3 className={classes.title}>{formatMessage({ id: 'SETTINGS_Clients' })}</h3>
      <Divider />
      <List className={classes.root}>
        {data &&
          data.Clients &&
          ((data.Clients as unknown) as any[])!.map((element: any, index: number) => {
            return (
              <div key={(element as any).Id}>
                <ListItem>
                  <ListItemText primary={(element as any).Name} />
                </ListItem>
                {index !== ((data.Clients as unknown) as any[])!.length - 1 && <Divider />}
              </div>
            );
          })}
      </List>
    </div>
  );
};
